var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',[_vm._v(_vm._s(_vm.$t('feed.fields.deletedCheckinDate')))]),_c('strong',[_vm._v(_vm._s(_vm.getDate(_vm.post.pda_checkin.date)))]),_c('span',[_vm._v(_vm._s(_vm.$t('feed.fields.deletedCheckinValue')))]),_c('strong',[_vm._v("\n        "+_vm._s(_vm.formatNumber(_vm.post.pda_checkin.current_value))+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }